import { gql } from '__generated__'

export const LINK_WALLET = gql(`
  mutation linkWallet($walletAddress: String!, $signature: String!) {
    linkWallet(walletAddress: $walletAddress, signature: $signature) {
      id
      address
      isPrimary
      createdAt
    }
  }
`)
